import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

// 屏蔽 ResizeObserver 错误（这是浏览器的一个已知问题，不影响功能）
const resizeObserverErr = 'ResizeObserver loop completed with undelivered notifications';
const resizeObserverErr2 = 'ResizeObserver loop limit exceeded';

window.addEventListener('error', (event) => {
  if (event.message === resizeObserverErr || event.message === resizeObserverErr2) {
    event.stopImmediatePropagation();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && (event.reason.message === resizeObserverErr || event.reason.message === resizeObserverErr2)) {
    event.stopImmediatePropagation();
  }
});

const app = createApp(App);

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(router);
app.use(ElementPlus);
app.mount('#app');
